import {GlobalConstants} from "../data/GlobalConstants";
import {handleResponse} from "../util/functions";
import {getToken} from "../helpers/helperJWT";

const url = GlobalConstants.urlApi;

export const generalService = {
    getAllRoles
    ,getAllPerfiles
    ,getDepartamentos
    ,getCiudades
    ,getPuntoVenta
    ,getTiposDocumentos
    ,getNaturalezaJuridica
    ,getRespFiscal
    ,getEstadosCiviles
    ,getRegFiscal
    ,getTipoImpuestos
    ,getIdiomas
    ,getPaises
    ,getSegmentos
    ,getMediosPago
    ,getTipologias
    ,getAgentesComerciales
    ,getVendedores
    ,getListaPrecios
    ,getPortafolios
    ,getCanales
    ,getSubCanales
    ,getCondicionesPago
    ,getFormasPago
    ,getNomenclatura
    ,getEstados
    ,getTiposSolicitudes
    ,getClasificacionProductos
    ,getMedidas
    ,getProveedores
    ,getProductos
    ,getTiposEmbalaje
    ,getTiposAlmacenaje
    ,getTipoProductos
    ,getMonedas
    ,getTipoLineasDocumentos
    ,getNecesidades
    ,getFrecuencias
    ,getModeloAtencion
    ,getCategoriasProductos
    ,getSubCategoriaProductos
    ,getLineaProductos
    ,getSubLineaProductos
    ,getMarcaProductos
    ,getSubMarcaProductos
    ,getMotivosInactivacionClientes
    ,getSegmentosNecesidad
    ,getEtiquetas
    ,getPlantilla
    ,getRegionales
    ,getPropietarios
    ,getGrupo5
};


function getAllRoles() {

    const requestOptions = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': getToken()
        },
        body: JSON.stringify({})
    };

    return fetch(`${url}/general/getAllRoles`, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        });
}

function getAllPerfiles() {

    const requestOptions = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': getToken()
        },
        body: JSON.stringify({})
    };

    return fetch(`${url}/general/getAllPerfiles`, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        });
}

function getDepartamentos() {

    const requestOptions = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': getToken()
        },
        body: JSON.stringify({})
    };

    return fetch(`${url}/general/getDepartamentos`, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        });
}

function getCiudades() {

    const requestOptions = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': getToken()
        },
        body: JSON.stringify({})
    };

    return fetch(`${url}/general/getCiudades`, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        });
}

function getPuntoVenta() {

    const requestOptions = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': getToken()
        },
        body: JSON.stringify({})
    };

    return fetch(`${url}/general/getPuntoVenta`, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        });
}

function getTiposDocumentos() {

    const requestOptions = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': getToken()
        },
        body: JSON.stringify({})
    };

    return fetch(`${url}/general/getTiposDocumentos`, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        });
}

function getNaturalezaJuridica() {

    const requestOptions = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': getToken()
        },
        body: JSON.stringify({})
    };

    return fetch(`${url}/general/getNaturalezaJuridica`, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        });
}

function getRespFiscal() {

    const requestOptions = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': getToken()
        },
        body: JSON.stringify({})
    };

    return fetch(`${url}/general/getRespFiscal`, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        });
}

function getEstadosCiviles() {

    const requestOptions = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': getToken()
        },
        body: JSON.stringify({})
    };

    return fetch(`${url}/general/getEstadosCiviles`, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        });
}


function getRegFiscal() {

    const requestOptions = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': getToken()
        },
        body: JSON.stringify({})
    };

    return fetch(`${url}/general/getRegFiscal`, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        });
}

function getTipoImpuestos() {

    const requestOptions = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': getToken()
        },
        body: JSON.stringify({})
    };

    return fetch(`${url}/general/getTipoImpuestos`, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        });
}

function getIdiomas() {

    const requestOptions = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': getToken()
        },
        body: JSON.stringify({})
    };

    return fetch(`${url}/general/getIdiomas`, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        });
}

function getPaises() {

    const requestOptions = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': getToken()
        },
        body: JSON.stringify({})
    };

    return fetch(`${url}/general/getPaises`, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        });
}


function getSegmentos() {

    const requestOptions = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': getToken()
        },
        body: JSON.stringify({})
    };

    return fetch(`${url}/general/getSegmentos`, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        });
}

function getMediosPago() {

    const requestOptions = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': getToken()
        },
        body: JSON.stringify({})
    };

    return fetch(`${url}/general/getMediosPago`, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        });
}

function getTipologias() {

    const requestOptions = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': getToken()
        },
        body: JSON.stringify({})
    };

    return fetch(`${url}/general/getTipologias`, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        });
}

function getAgentesComerciales() {

    const requestOptions = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': getToken()
        },
        body: JSON.stringify({})
    };

    return fetch(`${url}/general/getAgentesComerciales`, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        });
}

function getVendedores() {

    const requestOptions = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': getToken()
        },
        body: JSON.stringify({})
    };

    return fetch(`${url}/general/getVendedores`, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        });
}

function getListaPrecios() {

    const requestOptions = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': getToken()
        },
        body: JSON.stringify({})
    };

    return fetch(`${url}/general/getListaPrecios`, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        });
}

function getPortafolios() {

    const requestOptions = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': getToken()
        },
        body: JSON.stringify({})
    };

    return fetch(`${url}/general/getPortafolios`, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        });
}

function getNecesidades() {

    const requestOptions = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': getToken()
        },
        body: JSON.stringify({})
    };

    return fetch(`${url}/general/getNecesidades`, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        });
}


function getFrecuencias() {

    const requestOptions = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': getToken()
        },
        body: JSON.stringify({})
    };

    return fetch(`${url}/general/getFrecuencia`, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        });
}


function getModeloAtencion() {

    const requestOptions = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': getToken()
        },
        body: JSON.stringify({})
    };

    return fetch(`${url}/general/getModeloAtencion`, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        });
}

function getCanales() {

    const requestOptions = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': getToken()
        },
        body: JSON.stringify({})
    };

    return fetch(`${url}/general/getCanales`, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        });
}

function getSubCanales() {

    const requestOptions = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': getToken()
        },
        body: JSON.stringify({})
    };

    return fetch(`${url}/general/getSubCanales`, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        });
}

function getFormasPago() {

    const requestOptions = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': getToken()
        },
        body: JSON.stringify({})
    };

    return fetch(`${url}/general/getFormasPago`, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        });
}

function getCondicionesPago() {

    const requestOptions = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': getToken()
        },
        body: JSON.stringify({})
    };

    return fetch(`${url}/general/getCondicionesPago`, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        });
}

function getNomenclatura() {

    const requestOptions = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': getToken()
        },
        body: JSON.stringify({})
    };

    return fetch(`${url}/general/getNomenclatura`, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        });
}

function getEstados() {

    const requestOptions = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': getToken()
        },
        body: JSON.stringify({})
    };

    return fetch(`${url}/general/getEstados`, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        });
}

function getTiposSolicitudes() {

    const requestOptions = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': getToken()
        },
        body: JSON.stringify({})
    };

    return fetch(`${url}/clientes/getTiposSolicitudes`, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        });
}

function getClasificacionProductos() {

    const requestOptions = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': getToken()
        },
        body: JSON.stringify({})
    };

    return fetch(`${url}/general/getClasificacionProductos`, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        });
}

function getMedidas() {

    const requestOptions = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': getToken()
        },
        body: JSON.stringify({})
    };

    return fetch(`${url}/general/getMedidas`, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        });
}

function getProveedores() {

    const requestOptions = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': getToken()
        },
        body: JSON.stringify({})
    };

    return fetch(`${url}/general/getProveedores`, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        });
}

function getTiposAlmacenaje() {

    const requestOptions = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': getToken()
        },
        body: JSON.stringify({})
    };

    return fetch(`${url}/general/getTiposAlmacenaje`, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        });
}

function getTiposEmbalaje() {

    const requestOptions = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': getToken()
        },
        body: JSON.stringify({})
    };

    return fetch(`${url}/general/getTiposEmbalaje`, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        });
}

function getTipoProductos() {

    const requestOptions = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': getToken()
        },
        body: JSON.stringify({})
    };

    return fetch(`${url}/general/getTipoProductos`, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        });
}

function getProductos() {

    const requestOptions = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': getToken()
        },
        body: JSON.stringify({})
    };

    return fetch(`${url}/general/getProductos`, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        });
}

function getMonedas() {

    const requestOptions = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': getToken()
        },
        body: JSON.stringify({})
    };

    return fetch(`${url}/general/getMonedas`, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        });
}

function getTipoLineasDocumentos() {

    const requestOptions = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': getToken()
        },
        body: JSON.stringify({})
    };

    return fetch(`${url}/general/getTipoLineasDocumentos`, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        });
}

function getCategoriasProductos() {

    const requestOptions = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': getToken()
        },
        body: JSON.stringify({})
    };

    return fetch(`${url}/general/getCategoriasProductos`, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        });
}

function getSubCategoriaProductos() {

    const requestOptions = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': getToken()
        },
        body: JSON.stringify({})
    };

    return fetch(`${url}/general/getSubCategoriaProductos`, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        });
}

function getLineaProductos() {

    const requestOptions = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': getToken()
        },
        body: JSON.stringify({})
    };

    return fetch(`${url}/general/getLineaProductos`, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        });
}

function getSubLineaProductos() {

    const requestOptions = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': getToken()
        },
        body: JSON.stringify({})
    };

    return fetch(`${url}/general/getSubLineaProductos`, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        });
}

function getMarcaProductos() {

    const requestOptions = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': getToken()
        },
        body: JSON.stringify({})
    };

    return fetch(`${url}/general/getMarcaProductos`, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        });
}

function getSubMarcaProductos() {

    const requestOptions = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': getToken()
        },
        body: JSON.stringify({})
    };

    return fetch(`${url}/general/getSubMarcaProductos`, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        });
}


function getMotivosInactivacionClientes() {

    const requestOptions = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': getToken()
        },
        body: JSON.stringify({})
    };

    return fetch(`${url}/general/getMotivosInactivacionClientes`, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        });
}


function getSegmentosNecesidad() {

    const requestOptions = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': getToken()
        },
        body: JSON.stringify({})
    };

    return fetch(`${url}/general/getSegmentosNecesidad`, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        });
}



function getEtiquetas() {

    const requestOptions = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': getToken()
        },
        body: JSON.stringify({})
    };

    return fetch(`${url}/general/getEtiquetas`, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        });
}


function getPlantilla(datos) {

    const requestOptions = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': getToken()
        },
        body: JSON.stringify(datos)
    };

    return fetch(`${url}/general/getPlantilla`, requestOptions)
        .then(response => response.blob());
}




function getRegionales() {

  const requestOptions = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': getToken()
    },
    body: JSON.stringify({})
  };

  return fetch(`${url}/general/getRegionales`, requestOptions)
    .then(handleResponse)
    .then(response => {
      return response;
    });
}

function getPropietarios() {

  const requestOptions = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': getToken()
    },
    body: JSON.stringify({})
  };

  return fetch(`${url}/general/getPropietarios`, requestOptions)
    .then(handleResponse)
    .then(response => {
      return response;
    });
}

function getGrupo5() {

  const requestOptions = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': getToken()
    },
    body: JSON.stringify({})
  };

  return fetch(`${url}/general/getGrupo5`, requestOptions)
    .then(handleResponse)
    .then(response => {
      return response;
    });
}









